/**
 * These have to do ONLY with messages in Fabric Core! Examples would be
 * the labels of apps in the header, messages for 404s, Error
 * Boundaries, and so on.
 *
 * We're NOT helping developers with their app-specific I18n concerns.
 */

import enUS from "./en-US.json";
import enCA from "./en-CA.json";
import frCA from "./fr-CA.json";
import ptBR from "./pt-BR.json";

/**
 * This type ensures that people only select valid keys from messages.
 *
 * Any of the translation files would be fine—we have the same keys for each.
 */
export type CoreTranslations = { [key in keyof typeof enUS]: string };

/**
 * When you add a new we support, add a translations JSON and add the
 * new locale here. Make sure you update `constants/index.ts` as well.
 */
export const coreTranslationsMap = {
  "en-US": enUS,
  "en-CA": enCA,
  "fr-CA": frCA,
  "pt-BR": ptBR,
};
